import { HttpService } from "./http.service";
import { UnconfirmedLeadModel } from "../utils/types";

export class UnconfirmedLeadsService {
  static getUnconfirmedLeads(
    uuid: string,
    showSpinner = true
  ): Promise<UnconfirmedLeadModel> {
    return HttpService.get(
      `/whatsapp/unconfirmed-leads/${uuid}`,
      {},
      {},
      showSpinner
    ).then((res) => new UnconfirmedLeadModel(res));
  }
}
